/* This file must be last (i.e. after loading all javascripts) */
$.nette.init();
Bingo.AfterLoad.trigger();

$.nette.ext('afterAjaxSuccess', {
    success(data) {
        this.reinitialize(data);
    },
}, {
    reinitialize(data) {
        $(document).off('change', 'select[data-autosubmit-per-page]');
        $(document).on('change', 'select[data-autosubmit-per-page]', function () {
            return $(this).parent().parent().find('input[type=submit]')
                .click();
        });
        $(document).on('shown.bs.modal', '.modal', () => {
            Bingo.PricingPackages.init();
            Bingo.NavigationOffcanvas.closeNavigation();
        });

        Bingo.FlashMessages.init();
        Bingo.Tooltip.init();
        Bingo.OfferFilterFormProperty.init();
        Bingo.PricingPackages.init();
        Bingo.Preview.init();
        Bingo.TextField.labelUpCheck();
        Bingo.Select.init();
        Bingo.Alert.destroyTemporary();
        Bingo.FileUpload.init();

        if (
            typeof data !== 'undefined'
            && typeof data.state !== 'undefined'
            && typeof data.state['visualPaginator-page'] !== 'undefined'
        ) {
            const paginationPage = data.state['visualPaginator-page'];
            if (!Bingo.Pagination.isCurrentPage(paginationPage)) {
                Bingo.Pagination.page = paginationPage;
                Bingo.Pagination.toTop();
            }
        }
    },
});


$.nette.ext('afterAjaxSuccess').reinitialize();

Bingo.ActiveState.byNestedRadio('.radio-button');
Bingo.ActiveState.byNestedCheckbox('.checkbox-button');

Bingo.GalleryCarousel.init();

Bingo.AutoFocus.init();

Bingo.PricingPackages.init();

Bingo.TextField.init();

Bingo.NavigationHiding.init();

Bingo.NavigationOffcanvas.init();

Bingo.Tables.init();

Bingo.MortgageCalculator.init();

Bingo.MapOnDetail.init();

Bingo.Alert.init();

Bingo.DropdownFilter.init();

Bingo.FileUpload.init();

Bingo.PreviewTable.init();

Bingo.ContentSwitcher.init();

Bingo.HelpPopup.init();
